import "./sentry";

import "./utils/patchSetTimeout";
import { polyfillUrlCanParse } from "./utils/polyfillUrlCanParse";
import { silenceI18nextSupportNotice } from "./utils/silenceI18nextSupportNotice";

polyfillUrlCanParse();
silenceI18nextSupportNotice();

import axios from "axios";

window.axios = axios;

window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

import "./axios";
import "./echo";
